import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=5d409f29&scoped=true&"
import script from "./AppFooter.vue?vue&type=script&lang=js&"
export * from "./AppFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppFooter.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AppFooter.vue?vue&type=style&index=1&id=5d409f29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d409f29",
  null
  
)

export default component.exports